import { jsxs as a, jsx as r, Fragment as i } from "react/jsx-runtime";
import { InputLabel as l } from "@mui/material";
import { isTruthy as c } from "./types3.mjs";
import { LabelWrapper as s, InformerContainer as f } from "./styles27.mjs";
import { Informer as h } from "./index48.mjs";
import { Typography as m } from "./index59.mjs";
const u = ({
  children: e,
  required: t,
  isOptional: o
}) => /* @__PURE__ */ a(i, { children: [
  /* @__PURE__ */ r(m.TextMd.Regular, { children: e }),
  o && !t && /* @__PURE__ */ r(m.TextXs.Regular, { color: "text.tertiary", children: " (Optional)" })
] }), L = ({
  info: e,
  tooltipConfig: t,
  trigger: o,
  className: p,
  ...n
}) => /* @__PURE__ */ a(s, { className: p, children: [
  /* @__PURE__ */ r(l, { ...n, children: /* @__PURE__ */ r(u, { ...n }) }),
  c(e) && /* @__PURE__ */ r(f, { children: /* @__PURE__ */ r(
    h,
    {
      info: e,
      tooltipConfig: t,
      trigger: o
    }
  ) })
] });
export {
  L as InputLabel,
  u as InputLabelBase
};
//# sourceMappingURL=index46.mjs.map
